var _circle, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    r: 17.856,
    transform: "matrix(-1 0 0 1 18.2641 18.5435)",
    fill: "#262626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7281 15.5675C23.9608 15.5675 24.9601 14.5682 24.9601 13.3355C24.9601 12.1028 23.9608 11.1035 22.7281 11.1035C21.4954 11.1035 20.4961 12.1028 20.4961 13.3355C20.4961 14.5682 21.4954 15.5675 22.7281 15.5675Z",
    stroke: "white",
    strokeWidth: 1.116,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8001 20.7755C15.0328 20.7755 16.0321 19.7762 16.0321 18.5435C16.0321 17.3108 15.0328 16.3115 13.8001 16.3115C12.5674 16.3115 11.5681 17.3108 11.5681 18.5435C11.5681 19.7762 12.5674 20.7755 13.8001 20.7755Z",
    stroke: "white",
    strokeWidth: 1.116,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7281 25.9835C23.9608 25.9835 24.9601 24.9842 24.9601 23.7515C24.9601 22.5188 23.9608 21.5195 22.7281 21.5195C21.4954 21.5195 20.4961 22.5188 20.4961 23.7515C20.4961 24.9842 21.4954 25.9835 22.7281 25.9835Z",
    stroke: "white",
    strokeWidth: 1.116,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7271 19.667L20.8086 22.6281",
    stroke: "white",
    strokeWidth: 1.116,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8011 14.459L15.7271 17.4201",
    stroke: "white",
    strokeWidth: 1.116,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.ce1455b668862c43af8073eb54f69935.svg";
export { ForwardRef as ReactComponent };